import React, { useEffect, useState } from "react";
import {
  AttachmentField,
  Backdrop,
  Button,
  Chip,
  Divider,
  DocumentsList,
  FormFieldSet,
  LogoLoader,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { useAttachmentHandlers } from "../../../../../../../hooks/useAttachmentHandlers";
import {
  LcaAdsPostAt,
  LcaStatus,
  visaClassificationOptions,
} from "../../../../../../../assets/data/enumData";
import {
  cityStateListOptions,
  countryListOptions,
} from "../../../../../../../assets/data/projectData";
import ResetModal from "./Modals/ResetModal";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../../hooks/useLoginUser";
import { getEmployeeByUiidStart } from "../../../../../../../redux/slices/employee/employeeSlice";
import { addDocumentStart } from "../../../../../../../redux/slices/universal/documentsSlice";
import { addNewImmigrationsStart } from "../../../../../../../redux/slices/immigration/immigrationSlice";
import { uploadStart } from "../../../../../../../redux/slices/universal/fileUploadSlice";
import { transformFiles } from "../../../../../../../utils/transformFiles";
const LCAInformation = ({
  onCancel,
  isEdit,
  setIsEdit,
  data,
  setActiveTab,
  editData = null,
}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
  } = useSelector((state) => state.employee);
  const { userData: loginUserData } = useLoginUser();
  const {
    immigrations: immigrationTableData,
    currentImmgration,
    isLoading,
  } = useSelector((state) => state.immigration);
  const [activeAdTab, setActiveAdTab] = useState(1);
  const [activeTabInner, setActiveTabInner] = useState(1);
  const [tabToReset, setTabToReset] = useState(null);
  const [showResetModal, setShowResetModal] = useState(false);
  const [validationRules, setValidationRules] = useState({});
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [attchmentModalName, setAttachmentModalName] = useState("");
  const initialFormData = {
    lcaNumber: "",
    lcaStatus: "",
    jobTitle: "",
    employmentStartDate: "",
    employmentEndDate: "",
    certificationDate: "",
    positionsRequested: "",
    socCode: "",
    socOccupationTitle: "",
    includePoNumber: "exempt",
    visaClassification: [{ id: uuidv4(), visaClasificationSelect: [] }],
    certifiedLCA: [],
    paperLCA: [],
    // onlineLCA: [],
    // paperLCA: [],
    wageRateUSD: "",
    wageRateFromUSD: "",
    wageRateToUSD: "",
    wageRatePer: "",
    wageLevel: "",
    sourceYear: "",
    documentType: "",
    employeeId: "",
    employmentPlace: {
      place1: {
        id: uuidv4(),
        endClient: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
      place2: {
        id: uuidv4(),
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
      place3: {
        id: uuidv4(),
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
      place4: {
        id: uuidv4(),
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
    },
    // advertisements: {
    //   ad1: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    //   ad2: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    //   ad3: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    //   ad4: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    // },
    attachments: [
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  useEffect(() => {
    const baseRules = {
      paperLCA: {
        type: "file",
        required: true,
        // allowedFiles: [
        //   { ext: "png", mime: "image/png" },
        //   { ext: "txt", mime: "text/plain" },
        //   { ext: "pdf", mime: "text/plain" },
        // ],
      },
      certifiedLCA: {
        type: "file",
        required: true,
        // allowedFiles: [
        //   { ext: "png", mime: "image/png" },
        //   { ext: "txt", mime: "text/plain" },
        //   { ext: "pdf", mime: "text/plain" },
        // ],
      },
      attachments: [
        {
          // attachmentName: {
          //   type: "text",
          //   required: true,
          //   minLength: 3,
          // },
          chooseFiles: {
            type: "file",
            // required: true,
            // allowedFiles: [
            //   { ext: "png", mime: "image/png" },
            //   { ext: "txt", mime: "text/plain" },
            // ],
          },
        },
      ],

      socCode: {
        type: "text",
        required: true,
      },
      lcaStatus: {
        type: "select",
        required: true,
        number: true,
      },
      jobTitle: {
        type: "select",
        required: true,
      },
      employmentStartDate: {
        type: "date",
        required: true,
      },
      employmentEndDate: {
        type: "date",
        required: true,
      },
      certificationDate: {
        type: "date",
        required: true,
      },
      positionsRequested: {
        type: "text",
        required: true,
      },
      socOccupationTitle: {
        type: "text",
        required: true,
      },
      // includePoNumber: {
      //   type: "radio",
      //   required: true,
      // },
      wageRateUSD: {
        type: "text",
        required: true,
        number: true,
      },
      wageRateFromUSD: {
        type: "text",
        required: true,
        number: true,
      },
      wageRateToUSD: {
        type: "text",
        // required: true,
        number: true,
      },
      wageRatePer: {
        type: "select",
        required: true,
        number: true,
      },
      employeeId: {
        type: "select",
        required: true,
      },
      wageLevel: {
        type: "text",
        // required: true,
      },
      lcaNumber: {
        type: "text",
        required: true,
      },
      // employmentPlace: {
      //   place1: {
      //     prevailingWageUSD: {
      //       type: "text",
      //       required: true,
      //       number: true
      //     },
      //     endClient: {
      //       type: "text",
      //       required: true,
      //       number: true
      //     }
      //   }
      // },
    };
    setValidationRules(baseRules);
  }, []);

  const loginUserUiid = loginUserData?.uiid;

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const lca = {
        number: formData.lcaNumber,
        status: formData.lcaStatus,
        jobTitle: formData.jobTitle?.value ?? formData.jobTitle,
        employeeId: formData.employeeId?.value ?? formData.employeeId,
        employeeName: formData.employeeId,
        startDate: formData.employmentStartDate,
        endDate: formData.employmentEndDate,
        certifyDate: formData.certificationDate,
        positionReq: formData.positionsRequested,
        soc: {
          code: formData.socCode,
          title: formData.socOccupationTitle,
        },
        includePONum: formData.includePoNumber
          ? formData.includePoNumber === "exempt"
            ? true
            : false
          : "",
        visaClassification: formData.visaClassification.map(
          (data) => data.visaClasificationSelect,
        ),
        salaryInfo: {
          wageRate: formData.wageRateUSD,
          range: {
            from: formData.wageRateFromUSD,
            to: formData.wageRateToUSD,
          },
          level: formData.wageLevel,
          sourceYear: { from: formData.sourceFrom, to: formData.sourceTo },
          duration: formData.wageRatePer,
        },
        placeOfEmployment: [
          {
            endClient: formData.employmentPlace.place1.endClient,
            address: {
              country:
                formData.employmentPlace.place1.country?.value ??
                formData.employmentPlace.place1.country,
              state:
                formData.employmentPlace.place1.state?.value ??
                formData.employmentPlace.place1.state,
              city:
                formData.employmentPlace.place1.city?.value ??
                formData.employmentPlace.place1.city,
              zipCode: formData.employmentPlace.place1.zipCode,
              county: formData.employmentPlace.place1.county,
              addressLine1: formData.employmentPlace.place1.addressLine1,
              addressLine2: formData.employmentPlace.place1.addressLine2,
            },
            prevailWage: formData.employmentPlace.place1.prevailingWageUSD,
          },
          {
            endClient: formData.employmentPlace.place2.endClient,
            address: {
              country:
                formData.employmentPlace.place2.country?.value ??
                formData.employmentPlace.place2.country,
              state:
                formData.employmentPlace.place2.state?.value ??
                formData.employmentPlace.place2.state,
              city:
                formData.employmentPlace.place2.city?.value ??
                formData.employmentPlace.place2.city,
              zipCode: formData.employmentPlace.place2.zipCode,
              county: formData.employmentPlace.place2.county,
              addressLine1: formData.employmentPlace.place2.addressLine1,
              addressLine2: formData.employmentPlace.place2.addressLine2,
            },
            prevailWage: formData.employmentPlace.place2.prevailingWageUSD,
          },
          {
            endClient: formData.employmentPlace.place3.endClient,
            address: {
              country:
                formData.employmentPlace.place3.country?.value ??
                formData.employmentPlace.place3.country,
              state:
                formData.employmentPlace.place3.state?.value ??
                formData.employmentPlace.place3.state,
              city:
                formData.employmentPlace.place3.city?.value ??
                formData.employmentPlace.place3.city,
              zipCode: formData.employmentPlace.place3.zipCode,
              county: formData.employmentPlace.place3.county,
              addressLine1: formData.employmentPlace.place3.addressLine1,
              addressLine2: formData.employmentPlace.place3.addressLine2,
            },
            prevailWage: formData.employmentPlace.place3.prevailingWageUSD,
          },
          {
            endClient: formData.employmentPlace.place4.endClient,
            address: {
              country:
                formData.employmentPlace.place4.country?.value ??
                formData.employmentPlace.place4.country,
              state:
                formData.employmentPlace.place4.state?.value ??
                formData.employmentPlace.place4.state,
              city:
                formData.employmentPlace.place4.city?.value ??
                formData.employmentPlace.place4.city,
              zipCode: formData.employmentPlace.place4.zipCode,
              county: formData.employmentPlace.place4.county,
              addressLine1: formData.employmentPlace.place4.addressLine1,
              addressLine2: formData.employmentPlace.place4.addressLine2,
            },
            prevailWage: formData.employmentPlace.place4.prevailingWageUSD,
          },
        ],
        // advertisements: [
        //   {
        //     type: formData.advertisements.ad1.advertisementType,
        //     id: formData.advertisements.ad1.id,
        //     postedAt: formData.advertisements.ad1.postedAt,
        //     displayed: {
        //       from: formData.advertisements.ad1.displayedFrom,
        //       till: formData.advertisements.ad1.displayedUntil,
        //     },
        //     displayOnDashboard: formData.advertisements.ad1.displayOnDashboard
        //       ? true
        //       : false,
        //   },
        //   {
        //     type: formData.advertisements.ad2.advertisementType,
        //     id: formData.advertisements.ad2.id,
        //     postedAt: formData.advertisements.ad2.postedAt,
        //     displayed: {
        //       from: formData.advertisements.ad2.displayedFrom,
        //       till: formData.advertisements.ad2.displayedUntil,
        //     },
        //     displayOnDashboard: formData.advertisements.ad2.displayOnDashboard
        //       ? true
        //       : false,
        //   },
        //   {
        //     type: formData.advertisements.ad3.advertisementType,
        //     id: formData.advertisements.ad3.id,
        //     postedAt: formData.advertisements.ad3.postedAt,
        //     displayed: {
        //       from: formData.advertisements.ad3.displayedFrom,
        //       till: formData.advertisements.ad3.displayedUntil,
        //     },
        //     displayOnDashboard: formData.advertisements.ad3.displayOnDashboard
        //       ? true
        //       : false,
        //   },
        //   {
        //     type: formData.advertisements.ad4.advertisementType,
        //     id: formData.advertisements.ad4.id,
        //     postedAt: formData.advertisements.ad4.postedAt,
        //     displayed: {
        //       from: formData.advertisements.ad4.displayedFrom,
        //       till: formData.advertisements.ad4.displayedUntil,
        //     },
        //     displayOnDashboard: formData.advertisements.ad4.displayOnDashboard
        //       ? true
        //       : false,
        //   },
        // ],
      };
      const submissionData = filterEmptyValues(lca);
      const submissionDataFilter = {
        ...submissionData,
        // advertisements: submissionData.advertisements?.filter((ad) => {
        //   const keys = Object.keys(ad);
        //   // Remove if exactly 2 keys and they are 'id' and 'displayOnDashboard' with value false
        //   return !(
        //     keys.length === 2 &&
        //     keys.includes("id") &&
        //     keys.includes("displayOnDashboard") &&
        //     ad.displayOnDashboard === false
        //   );
        // }),
      };
      const cleanAttachmentscertifiedLCA =
        Array.isArray(formData.certifiedLCA) && formData.certifiedLCA.length > 0
          ? formData.certifiedLCA.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      const cleanAttachmentspaperLCA =
        Array.isArray(formData.paperLCA) && formData.paperLCA.length > 0
          ? formData.paperLCA.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      // const cleanAttachments = formData.attachments.filter(
      //   (att) =>
      //     att.attachmentName.trim() !== "" ||
      //     att.attachmentComments.trim() !== "" ||
      //     (att.chooseFiles && att.chooseFiles.length > 0)
      // );
      // const cleanattachmentsId = cleanAttachments.flatMap((doc) =>
      //   doc.chooseFiles.map((file) => {
      //     file.id = doc.id;
      //     return file;
      //   })
      // );

      // const separatedFiles = Object.values(formData.advertisements)
      //   .filter(
      //     (doc) => Array.isArray(doc.attachment) && doc.attachment.length > 0
      //   )
      //   .flatMap(
      //     (doc) =>
      //     (doc.attachment = doc.attachment.map((file) => {
      //       file.id = doc.id;
      //       return file;
      //     }))
      //   );
      const combineAllFiles = [
        ...cleanAttachmentscertifiedLCA,
        ...cleanAttachmentspaperLCA,
        // ...cleanattachmentsId,
        // ...separatedFiles,
      ];
      dispatch(
        uploadStart({
          uploadType: "multiple",
          field: "doc",
          uiid: formData.employeeId?.value ?? formData.employeeId,
          entity: "lcas",
          category: "lca",
          coll: "LCA", //WorkAuth
          doc: combineAllFiles,
          onSuccess: async (fileData) => {
            const updatedSubmissionData = {
              ...submissionDataFilter,
            };
            const isEditing = !!(currentImmgration?.uiid || editData?.uiid);
            const uiid = isEditing
              ? currentImmgration?.uiid || editData?.uiid
              : "";
            const finalPayload = isEditing
              ? [
                  {
                    type: "SET",
                    value: {
                      ...updatedSubmissionData,
                    },
                  },
                ]
              : {
                  addedBy: loginUserUiid,
                  employeeId: formData.employeeId?.value ?? formData.employeeId,
                  ...updatedSubmissionData,
                };
            dispatch(
              addNewImmigrationsStart({
                uiid: uiid,
                coll: "LCA",
                rsn: "lcaInfo",
                rsd: submissionDataFilter,
                payload: finalPayload,
                onSuccess: async (payload) => {
                  const delay = (ms) =>
                    new Promise((res) => setTimeout(res, ms));
                  if (cleanAttachmentscertifiedLCA.length > 0) {
                    await dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "LCA",
                        refId:
                          payload.data.data.lcaId || payload.data.data.doc.uiid,
                        refField: "attachments.certified",
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              parent: {
                                employee:
                                  formData.employeeId?.value ??
                                  formData.employeeId,
                              },
                              addedBy: loginUserUiid,
                              docType: "certified LCA",
                              ref: {
                                id:
                                  payload.data.data.lcaId ||
                                  payload.data.data.doc.uiid, // parent doc uiid this doc belongs to
                                entity: "LCA", // collection name this doc belongs to
                                path: `attachments.certified`,
                              },
                              file: cleanAttachmentscertifiedLCA.map((obj) => ({
                                name: "certified LCA",
                                comments: "certified LCA",
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                      }),
                    );
                    await delay(300); // Delay 300ms after first dispatch
                  }
                  if (cleanAttachmentspaperLCA.length > 0) {
                    await dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "LCA",
                        refId:
                          payload.data.data.lcaId || payload.data.data.doc.uiid,
                        refField: "attachments.paper",
                        // refPatchId: payload.data.data.targetPatchId,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              parent: {
                                employee:
                                  formData.employeeId?.value ??
                                  formData.employeeId,
                              },
                              addedBy: loginUserUiid,
                              docType: "online Paper",
                              ref: {
                                id:
                                  payload.data.data.lcaId ||
                                  payload.data.data.doc.uiid, // parent doc uiid this doc belongs to
                                entity: "LCA", // collection name this doc belongs to
                                path: `attachments.paper`,
                              },
                              file: cleanAttachmentspaperLCA.map((obj) => ({
                                name: "online Paper",
                                comments: "online Paper",
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                      }),
                    );
                    await delay(300); // Delay 300ms after first dispatch
                  }
                  // if (cleanattachmentsId.length > 0) {
                  //   await dispatch(
                  //     addDocumentStart({
                  //       coll: "Document",
                  //       refColl: "Immigration",
                  //       refId:
                  //         payload.data.data.immigrationId ||
                  //         payload.data.data.doc.uiid,
                  //       refField: "lca.$[elem].lcaDocs",
                  //       refPatchId: payload.data.data.targetPatchId,
                  //       payload: {
                  //         addedBy: loginUserUiid,
                  //         attachments: [
                  //           {
                  //             addedBy: loginUserUiid,
                  //             docType: formData?.documentType,
                  //             ref: {
                  //               id:
                  //                 payload.data.data.immigrationId ||
                  //                 payload.data.data.doc.uiid, // parent doc uiid this doc belongs to
                  //               entity: "Immigration", // collection name this doc belongs to
                  //               path: `lcaDocs`,
                  //             },
                  //             file: cleanattachmentsId.map((obj) => ({
                  //               name: obj.attachmentName,
                  //               comments: obj.attachmentComments,
                  //               keys: fileData
                  //                 .filter(
                  //                   (file) =>
                  //                     file?.fileRefId === obj.id && file.key
                  //                 ) // match and ensure key exists
                  //                 .map((file) => file.key),
                  //             })),
                  //           },
                  //         ],
                  //       },
                  //       //onSuccess: handleModalClose,
                  //       onSuccess: async () => {

                  //       },
                  //     })
                  //   );
                  //   await delay(300); // Delay 300ms after first dispatch
                  // }
                  // getEmployeeByUiidStart({
                  //   uiid: employeeProfileUiid,
                  //   tab: "immigration",
                  //   ret: "uiid profilePhotoUrl firstName middleName lastName jobTitle status employmentType email mobile immigrations ssn dob bloodType",
                  // })
                  setActiveTab((prev) => prev + 1);
                },
              }),
            );
          },
        }),
      );
    } else {
      showToast("Please fill the required fields", "error");
    }
  };
  const handleAddVisaRow = () => {
    const newRow = {
      id: uuidv4(),
      visaClasificationSelect: [],
    };

    setFormData((prev) => ({
      ...prev,
      visaClassification: [...prev.visaClassification, newRow],
    }));
  };

  const handleRemoveVisaRow = (id) => {
    const updatedVisa = formData.visaClassification.filter(
      (row) => row.id !== id,
    );
    setFormData({ ...formData, visaClassification: updatedVisa });
  };

  const handleVisaChange = (index, field, value) => {
    const updatedRows = [...formData.visaClassification];
    updatedRows[index][field] = value;
    setFormData({ ...formData, visaClassification: updatedRows });
  };

  const handleEmploymentPlaceChange = (field, value) => {
    const placeKey = `place${activeTabInner}`;
    console.log("placeKey", placeKey);
    setFormData({
      ...formData,
      employmentPlace: {
        ...formData.employmentPlace,
        [placeKey]: {
          ...formData.employmentPlace[placeKey],
          [field]: value,
        },
      },
    });
  };

  const handleAdvertisementChange = (field, value) => {
    const adKey = `ad${activeAdTab}`;
    console.log(`Updating ${adKey}.${field} to:`, value);
    setFormData((prevFormData) => {
      const updatedData = {
        ...prevFormData,
        advertisements: {
          ...prevFormData.advertisements,
          [adKey]: {
            ...prevFormData.advertisements[adKey],
            [field]: value,
          },
        },
      };
      console.log(
        "Updated form data (advertisements):",
        updatedData.advertisements,
      );
      return updatedData;
    });
  };

  const openResetModal = (tabIndex) => {
    setTabToReset(tabIndex);
    setShowResetModal(true);
  };

  const closeResetModal = () => {
    setShowResetModal(false);
    setTabToReset(null);
  };

  const handleResetEmploymentPlace = () => {
    const placeKey = `place${tabToReset}`;
    const resetPlace = {
      id: uuidv4(),
      addressLine1: "",
      addressLine2: "",
      city: "",
      country: "",
      state: "",
      county: "",
      zipCode: "",
      prevailingWageUSD: "",
    };

    // Add endClient only for first tab
    if (tabToReset === 1) {
      resetPlace.endClient = "";
    }

    setFormData({
      ...formData,
      employmentPlace: {
        ...formData.employmentPlace,
        [placeKey]: resetPlace,
      },
    });
    closeResetModal();
  };

  const { renderAttachments } = useAttachmentHandlers(
    formData,
    handleChange,
    errors,
  );

  const getCurrentPlace = () => {
    const placeKey = `place${activeTabInner}`;
    return formData.employmentPlace[placeKey] || {};
  };

  const getCurrentPlaceErrors = () => {
    return errors?.employmentPlace?.[`place${activeTabInner}`] || {};
  };

  const getCurrentAd = () => {
    const adKey = `ad${activeAdTab}`;
    return formData.advertisements[adKey] || {};
  };

  const getCurrentAdErrors = () => {
    return errors?.advertisements?.[`ad${activeAdTab}`] || {};
  };
  //   console.log("setEdit", setIsEdit);
  useEffect(() => {
    const lcaInfo = currentImmgration?.lcaInfo;
    if (!lcaInfo) return;
    // Simple flat fields update
    const updatedFormData = {
      ...formData,
      lcaNumber: lcaInfo.number ?? "",
      lcaStatus: lcaInfo.status ?? "",
      jobTitle: lcaInfo.jobTitle ?? "",
      employeeId: lcaInfo.employeeName ?? "",
      employmentStartDate: lcaInfo.startDate ?? "",
      employmentEndDate: lcaInfo.endDate ?? "",
      certificationDate: lcaInfo.certifyDate ?? "",
      positionsRequested: lcaInfo.positionReq ?? "",
      socCode: lcaInfo.soc?.code ?? "",
      socOccupationTitle: lcaInfo.soc?.title ?? "",
      includePoNumber: lcaInfo.includePONum === true ? "exempt" : "nonexempt",
    };

    // Salary Info - Ensure fields are handled correctly
    const salaryInfo = lcaInfo.salaryInfo ?? {};
    updatedFormData.wageRateUSD = `${salaryInfo.wageRate ?? ""}`;
    updatedFormData.wageRatePer = salaryInfo.duration ?? "";
    updatedFormData.wageLevel = salaryInfo.level ?? "";
    updatedFormData.sourceFrom = salaryInfo.sourceYear?.from ?? "";
    updatedFormData.sourceTo = salaryInfo.sourceYear?.to ?? "";
    updatedFormData.wageRateFromUSD = salaryInfo.range?.from ?? "";
    updatedFormData.wageRateToUSD = salaryInfo.range?.to ?? "";

    // Handle placeOfEmployment - Update the employmentPlace field
    if (Array.isArray(lcaInfo.placeOfEmployment)) {
      const updatedEmploymentPlace = { ...formData.employmentPlace };
      lcaInfo.placeOfEmployment.forEach((data, index) => {
        const placeKey = `place${index + 1}`;
        console.log("data", data);
        updatedEmploymentPlace[placeKey] = {
          endClient: data?.endClient ?? "",
          addressLine1: data?.address?.addressLine1 ?? "",
          addressLine2: data?.address?.addressLine2 ?? "",
          country: data?.address?.country ?? "",
          state: data?.address?.state ?? "",
          city: data?.address?.city ?? "",
          zipCode: data?.address?.zipCode ?? "",
          county: data?.county ?? "",
          prevailingWageUSD: data?.prevailWage ?? "",
        };
      });

      updatedFormData.employmentPlace = updatedEmploymentPlace;
    }
    // Update the entire form data (all fields)
    setFormData(updatedFormData);
  }, [currentImmgration]);
  useEffect(() => {
    const lcaInfo = editData;
    const lcaInfoData = currentImmgration?.lcaInfo;
    if ((!lcaInfo || Object.keys(lcaInfo).length === 0) && !isEditable) {
      return;
    }
    if (currentImmgration && Object.keys(currentImmgration).length > 0) {
      return "";
    }

    // Simple flat fields
    // Simple flat fields update
    const updatedFormData = {
      ...formData,
      lcaNumber: lcaInfo.number ?? "",
      lcaStatus: lcaInfo.status ?? "",
      jobTitle: lcaInfo.jobTitle ?? "",
      employmentStartDate: lcaInfo.startDate ?? "",
      employmentEndDate: lcaInfo.endDate ?? "",
      certificationDate: lcaInfo.certifyDate ?? "",
      positionsRequested: lcaInfo.positionReq ?? "",
      socCode: lcaInfo.soc?.code != null ? `${lcaInfo.soc.code}` : "",
      socOccupationTitle: lcaInfo.soc?.title ?? "",
      includePoNumber: lcaInfo.includePONum === true ? "exempt" : "nonexempt",
      employeeId: lcaInfo?.employeeId
        ? {
            label: lcaInfo.employeeId.firstName,
            value: lcaInfo.employeeId.uiid,
          }
        : "",
    };
    // Salary Info - Ensure fields are handled correctly
    const salaryInfo = lcaInfo.salaryInfo ?? {};
    updatedFormData.wageRateUSD = `${salaryInfo.wageRate ?? ""}`;
    updatedFormData.wageRatePer = salaryInfo.duration ?? "";
    updatedFormData.wageLevel = salaryInfo.level ?? "";
    updatedFormData.sourceFrom = salaryInfo.sourceYear?.from ?? "";
    updatedFormData.sourceTo = salaryInfo.sourceYear?.to ?? "";
    updatedFormData.wageRateFromUSD =
      salaryInfo.range?.from != null ? `${salaryInfo.range.from}` : "";

    updatedFormData.wageRateToUSD =
      salaryInfo.range?.to != null ? `${salaryInfo.range.to}` : "";
    // Handle placeOfEmployment - Update the employmentPlace field
    if (Array.isArray(lcaInfo.placeOfEmployment)) {
      const updatedEmploymentPlace = { ...formData.employmentPlace };
      lcaInfo.placeOfEmployment.forEach((data, index) => {
        const placeKey = `place${index + 1}`;
        console.log("data", data);
        updatedEmploymentPlace[placeKey] = {
          endClient: data?.endClient ?? "",
          addressLine1: data?.address?.addressLine1 ?? "",
          addressLine2: data?.address?.addressLine2 ?? "",
          country: data?.address?.country ?? "",
          state: data?.address?.state ?? "",
          city: data?.address?.city ?? "",
          zipCode: data?.address?.zipCode ?? "",
          county: data?.county ?? "",
          prevailingWageUSD: data?.prevailWage ?? "",
        };
      });
      updatedFormData.employmentPlace = updatedEmploymentPlace;
    }
    setFormData(updatedFormData);
  }, [editData]);
  const combinePaperAttachments = !currentImmgration?.lcaInfo
    ? transformFiles(editData?.attachments?.paper || [])
    : [];

  const combineCertifiedAttachments = !currentImmgration?.lcaInfo
    ? transformFiles(editData?.attachments?.certified || [])
    : [];
  return (
    <div className="px-4 py-6 border-[1px] border-neutrals-50 overflow-auto h-[73vh]">
      {isEdit && (
        <div className="mb-2">
          <PageHeader
            Section={
              <div className="flex">
                <Button
                  // type="icon"
                  variant="text"
                  icon={"arrow_left_alt"}
                  color="black"
                  title={"View LCA"}
                  onClick={onCancel}
                  className="pl-0!"
                />
                {/* <PageTitle title={"View LCA"} tag="p" /> */}
              </div>
            }
            RightSection={
              <div>
                <Button title={"Edit"} onClick={() => setIsEdit(false)} />
              </div>
            }
          />
        </div>
      )}
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"PLACEMENT INFORMATION"} tag="p" />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 2xl:grid-cols-4">
        <FormFieldSet
          type="text"
          title="LCA Number"
          placeholder="Enter LCA Number"
          value={formData.lcaNumber}
          onChange={(value) => handleChange("lcaNumber", value)}
          error={errors.lcaNumber}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title="LCA Status"
          placeholder="Select LCA Status"
          value={formData.lcaStatus}
          onChange={(value) => handleChange("lcaStatus", value)}
          error={errors.lcaStatus}
          options={LcaStatus}
          disabled={isEdit}
        />
        <FormFieldSet
          type="jobTitle"
          title="Job Title"
          placeholder="Enter Job Title"
          value={formData.jobTitle}
          onChange={(value) => handleChange("jobTitle", value)}
          error={errors.jobTitle}
          disabled={isEdit}
          showSearch
          showButton
        />
        <FormFieldSet
          type="datepicker"
          title="Employment Start Date"
          placeholder="Select Employment Start Date"
          value={formData.employmentStartDate}
          onChange={(value) => handleChange("employmentStartDate", value)}
          error={errors.employmentStartDate}
          maxDate={formData?.employmentEndDate}
          disabled={isEdit}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title="Employment End Date"
          placeholder="Select Employment End Date"
          value={formData.employmentEndDate}
          onChange={(value) => handleChange("employmentEndDate", value)}
          error={errors.employmentEndDate}
          minDate={formData?.employmentStartDate}
          disabled={isEdit}
        />
        <FormFieldSet
          type="datepicker"
          title="Certification Date"
          placeholder="Select Certification Date"
          value={formData.certificationDate}
          onChange={(value) => handleChange("certificationDate", value)}
          error={errors.certificationDate}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title="Positions Requested"
          placeholder="Enter Positions Requested"
          value={formData.positionsRequested}
          onChange={(value) => handleChange("positionsRequested", value)}
          error={errors.positionsRequested}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title="SOC (ONET/OES) Code"
          placeholder="Enter SOC Code"
          value={formData.socCode}
          onChange={(value) => handleChange("socCode", value)}
          error={errors.socCode}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title="SOC (ONET/OES) Occupation Title"
          placeholder="Enter SOC Occupation Title"
          value={formData.socOccupationTitle}
          onChange={(value) => handleChange("socOccupationTitle", value)}
          error={errors.socOccupationTitle}
          disabled={isEdit}
        />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 2xl:grid-cols-4">
        <FormFieldSet
          type="radio"
          title={"Include PO Number"}
          options={[
            {
              label: "Nonexempt",
              value: "nonexempt",
            },
            { label: "Exempt", value: "exempt" },
          ]}
          value={formData.includePoNumber}
          onChange={(event) =>
            handleChange("includePoNumber", event.target.value)
          }
          error={errors.includePoNumber}
          disabled={isEdit}
        />
        <FormFieldSet
          type="employees"
          title="Employee Name"
          placeholder="Select Employee Name"
          value={formData.employeeId}
          onChange={(value) => handleChange("employeeId", value)}
          error={errors.employeeId}
          disabled={isEdit}
          showSearch
        />
      </div>
      <div className="mt-6">
        {formData.visaClassification.map((row, index) => (
          <div
            key={row.id}
            className="grid grid-cols-2 xl:grid-cols-3 gap-8 mb-4 2xl:grid-cols-4"
          >
            <FormFieldSet
              type="select"
              title="Visa Classification"
              placeholder="Select Visa Classification"
              value={row.visaClasificationSelect}
              onChange={(value) =>
                handleVisaChange(index, "visaClasificationSelect", value)
              }
              error={
                errors?.visaClassification?.[index]?.visaClasificationSelect
              }
              options={visaClassificationOptions}
              disabled={isEdit}
            />
            <div className="flex gap-2 items-start mt-8">
              <Button
                type="icon"
                size="xs"
                icon="add"
                color="black"
                onClick={handleAddVisaRow}
                disabled={isEdit}
              />
              <Button
                type="icon"
                size="xs"
                icon="remove"
                color="danger"
                onClick={() => handleRemoveVisaRow(row.id)}
                disabled={formData.visaClassification.length === 1}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"ATTACHMENT"} tag="p" />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 2xl:grid-cols-4">
        <FormFieldSet
          type="file"
          title="Paper LCA"
          placeholder="Choose File"
          value={formData.paperLCA}
          onChange={(value) => handleChange("paperLCA", value)}
          error={errors.paperLCA}
          disabled={isEdit}
          multiple
        />
        <FormFieldSet
          type="file"
          title="Certified LCA"
          placeholder="Choose File"
          value={formData.certifiedLCA}
          onChange={(value) => handleChange("certifiedLCA", value)}
          error={errors.certifiedLCA}
          disabled={isEdit}
          multiple
        />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 2xl:grid-cols-4">
        {editData && (
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => {
              setAttachmentModal(!attachmentModal);
              setAttachmentModalName("paper");
            }}
          >
            <Chip
              label={`Attachments Paper:-${combinePaperAttachments.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
        )}
        {editData && (
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => {
              setAttachmentModal(!attachmentModal);
              setAttachmentModalName("certified");
            }}
          >
            <Chip
              label={`Attachments Certified:-${combineCertifiedAttachments.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
        )}
      </div>
      <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"SALARY INFORMATION"} tag="p" />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 2xl:grid-cols-4">
        <FormFieldSet
          type="text"
          title="Prevailing Wage Rate (USD)."
          placeholder="Enter Prevailing Wage Rate (USD)"
          value={formData.wageRateUSD}
          onChange={(value) => handleChange("wageRateUSD", value)}
          error={errors.wageRateUSD}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title="Wage Rate From (USD)"
          placeholder="Enter Wage Rate From (USD)"
          value={formData.wageRateFromUSD}
          onChange={(value) => handleChange("wageRateFromUSD", value)}
          error={errors.wageRateFromUSD}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title="Wage Rate To (USD)"
          placeholder="Enter Wage Rate To (USD)"
          value={formData.wageRateToUSD}
          onChange={(value) => handleChange("wageRateToUSD", value)}
          error={errors.wageRateToUSD}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title="Wage Rate Per"
          placeholder="Enter Wage Rate Per"
          value={formData.wageRatePer}
          onChange={(value) => handleChange("wageRatePer", value)}
          error={errors.wageRatePer}
          disabled={isEdit}
          options={[
            { label: "hour", value: 1 },
            { label: "week", value: 2 },
            { label: "bi-week", value: 3 },
            { label: "month", value: 4 },
            { label: "year", value: 5 },
          ]}
        />
        <FormFieldSet
          type="checkbox"
          title="Wage Level"
          options={[
            {
              label: "I",
              value: "1",
            },
            {
              label: "II",
              value: "2",
            },
            {
              label: "III",
              value: "3",
            },
            {
              label: "IV",
              value: "4",
            },
            {
              label: "V",
              value: "5",
            },
          ]}
          values={formData.wageLevel || []}
          onChange={(value) => handleChange("wageLevel", value)}
          error={errors.wageLevel}
          disabled={isEdit}
        />
        {/* <FormFieldSet
          type="text"
          title="Source Year"
          placeholder="Enter"
          value={formData.sourceYear}
          onChange={(value) => handleChange("sourceYear", value)}
          error={errors.sourceYear}
          disabled={isEdit}
        /> */}
        <FormFieldSet
          type="datepicker"
          title="Source From"
          placeholder="Select source From"
          value={formData.sourceFrom}
          onChange={(value) => handleChange("sourceFrom", value)}
          error={errors.sourceFrom}
          maxDate={formData?.sourceTo}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title="Source To"
          placeholder=" Select source To"
          value={formData.sourceTo}
          onChange={(value) => handleChange("sourceTo", value)}
          error={errors.sourceTo}
          minDate={formData?.sourceFrom}
        />
      </div>
      <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"PLACE OF EMPLOYMENT"} tag="p" />
            </div>
          }
        />
        <Divider />
        <div className="tabs mt-3">
          <div className="flex gap-2 flex-wrap">
            {[1, 2, 3, 4].map((tabIndex) => (
              <Button
                key={tabIndex}
                title={`Place of employment ${tabIndex}`}
                variant={activeTabInner === tabIndex ? "text" : "text"}
                onClick={() => setActiveTabInner(tabIndex)}
                color={activeTabInner === tabIndex ? "primary " : "black"}
                className={
                  activeTabInner === tabIndex
                    ? " border-b-2 border-primary text-primary rounded-none"
                    : " border-b-2 border-white text-black rounded-none"
                }
              />
            ))}
          </div>
          <Divider />
          <div className="flex">
            <div className="mt-2 grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 2xl:grid-cols-4 flex-1">
              {activeTabInner === 1 && (
                <FormFieldSet
                  type="text"
                  title="End Client"
                  placeholder="Enter End Client"
                  value={getCurrentPlace().endClient || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("endClient", value)
                  }
                  error={getCurrentPlaceErrors().endClient}
                  disabled={isEdit}
                />
              )}
              <FormFieldSet
                type="text"
                title="Address Line 1"
                placeholder="Enter Address Line 1"
                value={getCurrentPlace().addressLine1 || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("addressLine1", value)
                }
                error={getCurrentPlaceErrors().addressLine1}
                disabled={isEdit}
              />
              <FormFieldSet
                type="text"
                title="Address Line 2"
                placeholder="Enter Address Line 2"
                value={getCurrentPlace().addressLine2 || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("addressLine2", value)
                }
                error={getCurrentPlaceErrors().addressLine2}
                disabled={isEdit}
              />
              <FormFieldSet
                type="countriesUsAndCanada"
                title="Country"
                placeholder="Select Country"
                value={getCurrentPlace().country || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("country", value)
                }
                error={getCurrentPlaceErrors().country}
                options={countryListOptions}
              />
              <FormFieldSet
                type="states"
                title="State"
                placeholder="Select State"
                value={getCurrentPlace().state || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("state", value)
                }
                error={getCurrentPlaceErrors().state}
                options={cityStateListOptions}
                disabled={!getCurrentPlace().country}
                parentValue={{
                  country:
                    getCurrentPlace().country?.value ??
                    getCurrentPlace().country,
                }}
                showSearch
              />
              <FormFieldSet
                type="cities"
                title="City"
                placeholder="Select City"
                value={getCurrentPlace().city || ""}
                onChange={(value) => handleEmploymentPlaceChange("city", value)}
                error={getCurrentPlaceErrors().city}
                disabled={!getCurrentPlace().state}
                parentValue={{
                  country:
                    getCurrentPlace().country?.value ??
                    getCurrentPlace().country,
                  state:
                    getCurrentPlace().state?.value ?? getCurrentPlace().state,
                }}
                showSearch
              />
              {/* <FormFieldSet
                type="text"
                title="City"
                placeholder="Enter"
                value={getCurrentPlace().city || ""}
                onChange={(value) => handleEmploymentPlaceChange("city", value)}
                error={getCurrentPlaceErrors().city}
                disabled={isEdit}
              /> */}
              {/* <FormFieldSet
                type="select"
                title="Country"
                placeholder="Select Country"
                value={getCurrentPlace().country || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("country", value)
                }
                error={getCurrentPlaceErrors().country}
                options={countryListOptions}
                disabled={isEdit}
              />
              <FormFieldSet
                type="select"
                title="State"
                placeholder="Select State"
                value={getCurrentPlace().state || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("state", value)
                }
                error={getCurrentPlaceErrors().state}
                options={cityStateListOptions}
                disabled={isEdit}
              /> */}
              <FormFieldSet
                type="text"
                title="County"
                placeholder="Select County"
                value={getCurrentPlace().county || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("county", value)
                }
                error={getCurrentPlaceErrors().county}
                disabled={isEdit}
              />
              <FormFieldSet
                type="text"
                title="Zip Code"
                placeholder="Enter Zip Code"
                value={getCurrentPlace().zipCode || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("zipCode", value)
                }
                error={getCurrentPlaceErrors().zipCode}
                disabled={isEdit}
              />
              <FormFieldSet
                type="text"
                title="Prevailing Wage (USD)"
                placeholder="Enter Prevailing Wage (USD)"
                value={getCurrentPlace().prevailingWageUSD || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("prevailingWageUSD", value)
                }
                error={getCurrentPlaceErrors().prevailingWageUSD}
                disabled={isEdit}
              />
            </div>
            <div className="flex-end mt-7">
              {activeTabInner !== 1 && (
                <Button
                  type="icon"
                  variant="text"
                  icon="delete"
                  onClick={() => openResetModal(activeTabInner)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex gap-3 justify-end my-6">
        <Button title="Cancel" variant="outlined" onClick={onCancel} />
        <Button title="Save" onClick={() => handleSave()} />
      </div>

      <ResetModal
        isOpen={showResetModal}
        onClose={() => closeResetModal()}
        onConfirm={() => handleResetEmploymentPlace()}
        title="Clear LCA Place Of Employment"
      />
      <Modal
        isOpen={attachmentModal}
        onClose={() => {
          setAttachmentModal(false);
          setAttachmentModalName("");
        }}
        width="max-w-2xl"
        title={"Document Details"}
      >
        <DocumentsList
          data={
            attchmentModalName === "paper"
              ? combinePaperAttachments
              : attchmentModalName === "certified"
                ? combineCertifiedAttachments
                : []
          }
        />
      </Modal>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default LCAInformation;
